module.exports = __webpack_public_path__ + "img/more_circle.9fe226fc.svg";